module.exports = __webpack_public_path__ + "img/multimodal_fb.69b2f15d.png";